import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import LoadingIndicator from '../../common/loading-indicator'

const useStyles = makeStyles(() => ({
  loaderBackground: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    zIndex: 5
  }
}))

const Loader = () => {
  const classes = useStyles()
  return (
    <div className={classes.loaderBackground}>
      <LoadingIndicator />
    </div>
  )
}

export default Loader
